import React from "react";
import PropTypes from "prop-types";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UIInput from "../UIInput";

import "./_UISearchField.scss";

const searchIconColor = "var(--color-foreground-subtle)";

const UISearchField = ({ placeholder, IconSx, ...props }) => (
  <UIInput
    className="ui-search-field"
    placeholder={placeholder}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon
            sx={{
              fontSize: "24px",
              color: searchIconColor,
              ...IconSx,
            }}
          />
        </InputAdornment>
      ),
    }}
    {...props}
  />
);

UISearchField.propTypes = {
  placeholder: PropTypes.string,
  IconSx: PropTypes.object,
};

UISearchField.defaultProps = {
  placeholder: "Search",
  IconSx: {},
};

export default UISearchField;
